/* eslint-disable react-hooks/exhaustive-deps */
import {
  FunctionComponent as F,
  Fragment,
  useEffect,
  useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { IState } from '../../core/store/store';
import {
  Box,
  Stack,
  Grid } from '@mui/material';
import Container from '../../components/UI/Container/Container';
import PageHeadline from '../../components/UI/Text/PageHeadline';
import Button from '../../components/UI/Button/Button';
import { HOME, LOGIN, MM_PROTOCOL, SAVE_MM_PROTOCOL, SAVE_PUBLIC_PROTOCOL } from '../../core/router/paths';
import loadingGif from '../../images/loading.gif';
import Drawer from '../../components/Drawer/Drawer';
import { updateSaveMmProtocolId } from '../../core/store/protocol/protocol.slice';
import { MmProtocol, MmProtocolInfo, MmProtocolDosing, getMmProtocol, getMmProtocolDosings } from '../../core/http/mmProtocol';
import MmProtocolTable from '../../components/MmProtocol/MmProtocolTable';
import { DosingRowState } from '@protoplan/types';



interface IParams
{
  mmProtocolId?: string
}

type TDoseRow = MmProtocolDosing & DosingRowState;

const MmProtocol: F = () =>
{
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams() as IParams;
  const mmProtocolId = Number(params.mmProtocolId);

  const user = useSelector((state: IState) => state.user);
  const [protocol, setProtocol] = useState<MmProtocol | undefined>(undefined);
  const dosingRows = protocol?.dosings as TDoseRow[] | undefined;


  useEffect(() =>
  {
    if(!params.mmProtocolId)
      return navigate(MM_PROTOCOL);

    Promise.all([getMmProtocol(mmProtocolId), getMmProtocolDosings(mmProtocolId)])
      .then(async(res: [MmProtocolInfo | undefined | void, void | MmProtocolDosing[]]) =>
      {
        if(!res[0] || !res[1])
        {
          console.log("navigate 0 - failed to retrieve MM Protocol");
          return navigate(HOME);
        }

        dispatch(updateSaveMmProtocolId(mmProtocolId));
        setProtocol({ ...res[0], dosings: res[1] });
      })
      .catch(err =>
      {
        console.log(err);
        navigate(HOME);
      });
  }, [params.mmProtocolId]);


  const [rowsSelected, setRowsSelected] = useState(dosingRows ? !dosingRows.every(row => !row.checked) : false);
  useEffect(() =>
  {
    setRowsSelected(dosingRows ? !dosingRows.every(row => !row.checked) : false);
  }, [dosingRows]);

  if(!protocol)
    return <></>;

  return (
    <Stack direction='row'>

      <Drawer/>

      <Container width='100%'>
        <Stack spacing={2} sx={{ width: '1160px' }}>
          <Grid item style={{ display: "flex", justifyContent: "flex-start", flexGrow: 1 }}>
            <PageHeadline>{protocol.name}</PageHeadline>
          </Grid>

          {protocol ?
            <MmProtocolTable protocol={protocol}/> :
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <img src={loadingGif} width='100px'/>
            </Box>}

          <Box width='1160px'>
            <Box sx={{ display: 'inline-flex', float: 'left' }}>
              {rowsSelected ?
                <Button
                  label='Copy to protocol'
                  size='large'/> :
                <Fragment />}
            </Box>
            {user.username ?
              <Button
                id='DuplicateProtocol'
                label='Duplicate protocol 💾'
                onClick={() => {}}/> :
              <Button
                id='LogInSaveProtocol'
                label='Log in to save protocol 💾'
                onClick={() => navigate(LOGIN + "/" + SAVE_MM_PROTOCOL, { relative: 'path' })}/>}
          </Box>

        </Stack>
      </Container>

    </Stack>
  );
};

export default MmProtocol;
